module.exports = __webpack_public_path__ + "static/media/Industry Specific Roles.d4a7e44f.png";